module.exports = __webpack_public_path__ + "img/partnerLeft.00218aac.png";